// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.readonly-input-with-edit-link input.disabled{cursor:not-allowed;background-color:#eee}`, "",{"version":3,"sources":["webpack://./app/javascript/components/ReadOnlyInputWithEditLink/ReadOnlyLinkWithEditLink.scss"],"names":[],"mappings":"AACE,8CACE,kBAAA,CACA,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
